import { CoreService } from '../services';
import { QueovalDik } from '../models';
import { HttpHeaders, HttpRequest } from '@angular/common/http';

export enum eHeadersMode {
  DEFAULT = 'default',
  EMPTY = 'empty',
  UPLOAD = 'upload',
  FORMDATA = 'formdata'
}

export class BaseInterceptor {
  private urlsList: Array<QueovalDik> = [];

  constructor(protected indParam: CoreService) {

  }

  /** @description get the request mode (default/empty/upload)
  * @param requestUrl the request url
  * @return the cloned request with the headers
  */
  setUrlMode(requestUrl: string): string {
    this.initUrls();

    let headerMode: string = eHeadersMode.DEFAULT;
    const urlElement: QueovalDik[] = this.urlsList.filter((u: QueovalDik) => requestUrl.toLowerCase().indexOf(u.key.toLowerCase()) > -1);
    if (urlElement && urlElement.length > 0) {
      headerMode = urlElement[0].value;
    }
    //  let headerMode: string = eHeadersMode.DEFAULT;
    //  for (let num: number = 0; num <= this.urlsList.length; num++) {
    //    const item: QueovalDik = this.urlsList[num];
    //    if (item.key.toLowerCase().indexOf(requestUrl.toLowerCase()) > -1) {
    //      headerMode = item.value;
    //      break;
    //    }
    //  }
    return headerMode;
  }

  /** @description clone the request adding the necessary headers
  * @param request the request object sent to the server
  * @return the cloned request with the headers
  */
  protected setUrlHeaders(request: HttpRequest<any>): HttpRequest<any> {
    const headerMode: string = this.setUrlMode(request.url);
    switch (headerMode) {
      case eHeadersMode.DEFAULT:
        const clt: string = this.indParam.AppParams.culture ? this.indParam.AppParams.culture : '';
        const gmt: string = this.indParam.AppParams.GMT ? this.indParam.AppParams.GMT : '';
        const tkn: string = this.indParam.AppParams.token ? this.indParam.AppParams.token : '';
        const tknAut: string = this.indParam.AppParams.tokenApiAut ? this.indParam.AppParams.tokenApiAut : '';

        let headers: HttpHeaders = new HttpHeaders();

        if (tknAut !== null && tknAut !== undefined && tknAut !== '') {
          headers = request.headers
            .append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
            .append('Access-Control-Allow-Headers', 'Content-Type, Authorization, Origin, Accept, X-Requested-With, Access-Control-Request-Method, Access-Control-Request-Headers')
            .append('Accept-Language', clt)
            .append('Content-Type', 'application/json')
            .append('Qgmt', gmt)
            .append('Queoval', tkn)
            .append('Authorization', tknAut)
        } else {
          headers = request.headers
            .append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
            .append('Access-Control-Allow-Headers', 'Content-Type, Authorization, Origin, Accept, X-Requested-With, Access-Control-Request-Method, Access-Control-Request-Headers')
            .append('Accept-Language', clt)
            .append('Content-Type', 'application/json')
            .append('Qgmt', gmt)
            .append('Queoval', tkn)
        }

        return request.clone({ headers });
      case eHeadersMode.FORMDATA:
      case eHeadersMode.UPLOAD:
        return request.clone({
          headers: request.headers
            .append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
            .append('Access-Control-Allow-Headers', 'Content-Type, Authorization, Origin, Accept, X-Requested-With, Access-Control-Request-Method, Access-Control-Request-Headers')
        });
      case eHeadersMode.EMPTY:
      default:
        return request;
    }
  }

  /** @description load the list of urls with specific treatment
  * @return void
  */
  private initUrls(): void {
    if (this.urlsList.length === 0) {
      this.urlsList.push(new QueovalDik('queoval.json', eHeadersMode.EMPTY));
      this.urlsList.push(new QueovalDik('config.json', eHeadersMode.EMPTY));
      this.urlsList.push(new QueovalDik('conf.library.json', eHeadersMode.EMPTY));
      this.urlsList.push(new QueovalDik('api/loginapp', eHeadersMode.EMPTY));                 // login control for all of the app
      this.urlsList.push(new QueovalDik('api/externallogin', eHeadersMode.EMPTY));            // login google/ms

      this.urlsList.push(new QueovalDik('api/authform', eHeadersMode.EMPTY));                 // ELEARNING / QUESTIONNAIRE
      this.urlsList.push(new QueovalDik('api/recoverymail', eHeadersMode.EMPTY));             // ELEARNING / QUESTIONNAIRE
      this.urlsList.push(new QueovalDik('api/streamupload', eHeadersMode.UPLOAD));            // ELEARNING / QUESTIONNAIRE / EXTRANET
      this.urlsList.push(new QueovalDik('api/upload/', eHeadersMode.UPLOAD));                  // ELEARNING / QUESTIONNAIRE / EXTRANET / QUEOVAL
      this.urlsList.push(new QueovalDik('api/Upload', eHeadersMode.UPLOAD));                  // ELEARNING / QUESTIONNAIRE / EXTRANET / QUEOVAL
      this.urlsList.push(new QueovalDik('api/uploadv2', eHeadersMode.UPLOAD));                // ELEARNING / QUESTIONNAIRE

      this.urlsList.push(new QueovalDik('api/signatureStreamExtranet', eHeadersMode.UPLOAD));     // EXTRANET
      this.urlsList.push(new QueovalDik('api/UploadMedia', eHeadersMode.FORMDATA));               // ELEARNING / QUESTIONNAIRE / EXTRANET / QUEOVAL

      this.urlsList.push(new QueovalDik('pageapihttp.aspx', eHeadersMode.EMPTY));             // EXTRANET / QUEOVAL
      this.urlsList.push(new QueovalDik('pageapiauth.aspx', eHeadersMode.EMPTY));             // EXTRANET / QUEOVAL

      this.urlsList.push(new QueovalDik('api/queovalauth', eHeadersMode.EMPTY));              // QUEOVAL
      this.urlsList.push(new QueovalDik('api/streamuploadqueoval', eHeadersMode.UPLOAD));     // QUEOVAL
      this.urlsList.push(new QueovalDik('api/signatureStreamQueoval', eHeadersMode.UPLOAD));     // QUEOVAL


      this.urlsList.push(new QueovalDik('api/extraUpload', eHeadersMode.UPLOAD));             // WEBSTORE
    }
  }
}
